import { fork, call, put, all, takeEvery } from "redux-saga/effects";
import asyncInterface from "../../../../asyncInterface";
import * as actionTypes from './actionTypes';

function fetchAccountData(fetchPayload) {
  const fetchData = asyncInterface.init();
  return fetchData.investmentOptionDetails.fetchAccountData(fetchPayload);
}

function* investmentUSTFetch(data) {
  yield put({
    type: actionTypes.investmentOptionUstDataLoaderType,
    payload: ""
  });
  try {
    const response = yield call(fetchAccountData, data);    
    yield put({
      type: actionTypes.investmentOptionUstDataType,
      payload: response.data
    });
  } catch (error) {
    yield put({
      type: actionTypes.ustFailedType,
      error
    });
  }
}

function* myInvestmentUSTFetch(data) {
  yield put({
    type: actionTypes.myInvestmentOptionUstDataLoaderType,
    payload: ""
  });
  try {
    const response = yield call(fetchAccountData, data);
    yield put({
      type: actionTypes.myInvestmentOptionUstDataType,
      payload: response.data
    });
  } catch (error) {
    yield put({
      type: actionTypes.myInvestmentOptionUstFailedType,
      error
    });
  }
}


function* investmentDrupalFetch(data) {
  yield put({
    type: actionTypes.investmentOptionDrupalDataLoaderType,
    payload: ""
  });
  try {
    const response = yield call(fetchAccountData, data);
    yield put({
      type: actionTypes.investmentOptionDrupalDataType,
      payload: response.data
    });
  } catch (error) {
    yield put({
      type: actionTypes.drupalFailedType,

      error
    });
  }
}

function* underlyingDrupalFetch(data) {
  yield put({
    type: actionTypes.underlyingOptionDrupalDataLoaderType,
    payload: ""
  });
  try {
    const response = yield call(fetchAccountData, data);
    yield put({
      type: actionTypes.underlyingOptionDrupalDataType,
      payload: response.data
    });
  } catch (error) {
    yield put({
      type: actionTypes.underlyingFailedType,
      error
    });
  }
}

function* quaterlyReportDrupalFetch(data) {
  yield put({
    type: actionTypes.quaterlyReportDrupalDataLoaderType,
    payload: ""
  });
  try {
    const response = yield call(fetchAccountData, data);
    yield put({
      type: actionTypes.quaterlyReportDrupalDataType,
      payload: response.data
    });
  } catch (error) {
    yield put({
      type: actionTypes.quaterlyReportFailedType,
      error
    });
  }
}


function* fetchAccountDataWorker(fetchPayload) {
  yield all([
    fork(investmentUSTFetch, fetchPayload.payload.metaData[0]),
    fork(myInvestmentUSTFetch, fetchPayload.payload.metaData[1]),
    fork(investmentDrupalFetch, fetchPayload.payload.metaData[2]),
    fork(underlyingDrupalFetch, fetchPayload.payload.metaData[3]),
    fork(quaterlyReportDrupalFetch, fetchPayload.payload.metaData[4])
  ]);
}

function* fetchAccountDataWatcher() {
  yield takeEvery(actionTypes.fetchInvestmentOptionDataType, fetchAccountDataWorker);
}

function* fetchTableDataWorker(fetchPayload) {
  try {
    const response = yield call(
      fetchAccountData,
      fetchPayload.payload.metaData
    );
    yield put({
      type: actionTypes.fetchUnderlyingTableDataSuccessType,
      payload: response.data
    });
  } catch (error) {
    yield put({
      type: actionTypes.fetchUnderlyingTableDataFailureType,
      error
    });
  }
}
function* fetchTableDataWatcher() {
  yield takeEvery(actionTypes.fetchUnderlyingTableDataType, fetchTableDataWorker);
}
export default function* commonSagaWatcher() {
  yield all([fork(fetchAccountDataWatcher), fork(fetchTableDataWatcher)]);
}
